export default __webpack_public_path__ + "static/media/n.bb1e2361.png";